import clsx from "classnames";
import React from "react";

import sharedStyles from "../../styles/shared/inputs.module.css";
import styles from "./index.module.css";

interface RadioProps extends Omit<React.ComponentProps<"input">, "checked"> {
  /** Id used for htmlFor label and input */
  id?: string;
  /** If is checked */
  isChecked?: boolean;
  /** If is disabled */
  isDisabled?: boolean;
  /** Placement of input and text */
  inputPlacement?: "left" | "right";
  /** Label for the radio, can contain HTML */
  children?: React.ReactNode;
  /** Change handler for the radio */
  onChange?: (event: React.ChangeEvent<HTMLInputElement>) => void;
  /** ID(s) of elements that describe this radio (for error messages, help text, etc.) */
  "aria-describedby"?: string;
}

/** Mutually exclusive group of options. */

const Radio: React.FC<RadioProps> = ({
  className,
  id,
  isChecked = false,
  isDisabled = false,
  inputPlacement = "left",
  children,
  onChange,
  "aria-describedby": ariaDescribedby,
  ...rest
}) => {
  const classes = clsx(
    styles.label,
    styles[inputPlacement],
    {
      [sharedStyles.isDisabled]: isDisabled,
      [styles.isChecked]: isChecked,
      [styles.inputRight]: inputPlacement === "right",
    },
    className
  );

  const inputClasses = clsx(styles.hiddenInput, sharedStyles.hiddenInput);

  return (
    <label className={classes} htmlFor={id}>
      <input
        className={inputClasses}
        type="radio"
        disabled={isDisabled}
        checked={isChecked}
        onChange={onChange}
        aria-describedby={ariaDescribedby}
        id={id}
        {...rest}
      />
      <div className={styles.inputImage}></div>
      {children && <div className={styles.labelText}>{children}</div>}
    </label>
  );
};

export default Radio;
